// extracted by mini-css-extract-plugin
export default {"lifehack":"LifehackCard_lifehack__qBtty","lifehack__title":"LifehackCard_lifehack__title__rwcCt","lifehack__description":"LifehackCard_lifehack__description__gwFJt"};